import { setPeekState } from '../actions/itemPeekActions';
import { hideItemPeek } from '../actions/hideItemPeek';
import { closeItemPeek } from '../actions/closeItemPeek';
import { lazyLogFloodgateActivity } from 'owa-floodgate-feedback-view';
import { orchestrator } from 'satcheljs';
import { lazyResetMobilityBookends } from 'owa-mobility-read-view';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Close calendar item peek
 */
orchestrator(closeItemPeek, async actionMessage => {
    setPeekState(null);

    // Call dummy action for stitches
    hideItemPeek();

    // Log floodgate activity for viewing an event. If the user doesn't belong to this group, triggering will be a no-op.
    const logFloodgateActivity = await lazyLogFloodgateActivity.import();
    logFloodgateActivity('EventViewed');

    if (isFeatureEnabled('cal-mf-mobility')) {
        lazyResetMobilityBookends.importAndExecute();
    }
});
